import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { ProjectHolder } from '../../../../interfaces/project-holder';
import { ProjectService } from '../../../../data/project/project.service';
import { Project } from '../../../../data/project/project';
import { ProjectComment } from '../../../../data/project/project-comment';
import { User } from 'projects/core/src/lib/login/data/user';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-add-comment',
  templateUrl: './add-comment.component.html',
  styleUrls: ['./add-comment.component.scss']
})
export class AddCommentComponent implements OnInit {
  @Input()
  users: User[];

  project: Project

  showInput = false;

  itemDescription: string;

  @Output() closeAction = new EventEmitter<void>();

  @ViewChild('punchItemTextArea', {static: true})
  punchItemTextArea: ElementRef;

  loadingSpinner = false;

  ctrlEventListener = null;
  tempKey: any;
  timerSub: Subscription;

  constructor(
    protected projectHolder: ProjectHolder,
    protected projectService: ProjectService,
  ) {
    this.project = this.projectHolder.project
  }

  ngOnInit() {
  }

  subToCTRLEnter() {
    this.ctrlEventListener = (event: KeyboardEvent) => {
      this.ctrlEnterEvent(event)
    }

    document.addEventListener('keydown', this.ctrlEventListener);
  }

  ctrlEnterEvent(event) {
    const key = (event as KeyboardEvent).key; // const {key} = event; in ES6+

    if(this.tempKey === 'Control') {
      if(key === 'Enter') {
        if(this.itemDescription && this.itemDescription.length >= 3) {
          this.addComment();
        }
      }
    }
    this.tempKey = key;

    if(!this.timerSub) {
      this.timerSub = timer(500).subscribe(eimt => {
        this.tempKey = null;
        this.timerSub = null;
      })
    }
  }

  focusOnInput() {
    this.subToCTRLEnter();
  }

  showInputItem() {
    this.showInput = true;
    this.closeAction.emit();
  }

  addComment() {
    this.loadingSpinner = true;

    const commentData: ProjectComment = {
      id: null,
      text: this.itemDescription
    }

    this.projectService.addComment(this.project.id, commentData).subscribe(comment => {
      this.project.comments.push(comment)
      this.itemDescription = '';
      this.loadingSpinner = false;
    }, error => {
      this.loadingSpinner = false;
    })
  }

  hideInputItem() {
    this.showInput = false;
    this.itemDescription = ''
  }

  onMentionSelect(user: User) {
    return '@' + user.username + ' ';
  }


}
